import { render, staticRenderFns } from "./ExpenseManagement.vue?vue&type=template&id=00fb96ea"
import script from "./ExpenseManagement.vue?vue&type=script&lang=js"
export * from "./ExpenseManagement.vue?vue&type=script&lang=js"
import style0 from "./ExpenseManagement.vue?vue&type=style&index=0&id=00fb96ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports